import { calculateTotalHoursWithConsumptionFactor } from "components/timesheet/utils";
import {  fetchTimesheetApprovedHoursForMilestone } from "components/milestone/stats/consumed/api";
import { useQuery } from "@tanstack/react-query";
import { milestoneKeys } from "components/milestone/queries";

export function useMilestoneConsumedHours(id, dateRange) {
  return useQuery({
    queryFn: () => fetchTimesheetApprovedHoursForMilestone({ id, dateRange }),
    queryKey: milestoneKeys.allApprovedHours(id, dateRange),
    select: (data) =>
      calculateTotalHoursWithConsumptionFactor(data, "approved_hours"),
    enabled: !!id,
  });   
}
